const ARDashboard =()=>{
    return (
        <div>
            Dashboard
        </div>
    )
}

export default ARDashboard;